// extracted by mini-css-extract-plugin
export default {"shadowBox":"ShadowBox_shadowBox__k60fv"};